import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *新增资料
 * 
*/

export const compile = params => Http.post(`${baseUrl}/python/tools`, params )
